
<script>
export default {
    name: "ImportComponent",

    props: ['groupsUrl', 'fieldsUrl', 'importUrl', 'importErrorMessage', 'integrated'],

    data: function () {
        return {
            groups: {
                data: [],
                status: null,
            },
            fields: {
                group: {},
                data: [],
                status: null,
            },

            loading: {
                groups: false,
                fields: false,
                import: false,
            },

            selectedFields: Array,

            company_id: null,

            errors: {}
        };
    },

    mounted() {
        if(this.integrated) {
            this.loadGroups();
        }

    },

    computed: {
        isDisabledToImport: function () {
            if(this.selectedFields.length === 0) {
                return true;
            }

            return this.company_id === null || this.company_id === undefined;
        },

        isAllSelected() {
            return this.selectedFields.length === this.fields.data.length;
        }
    },

    methods: {

        redirectTo(destination) {
            window.location.href = destination;
        },

        setLoadingStatus(type, status = true) {
            this.loading[type] = status;
        },

        loadGroups() {
            this.setLoadingStatus('groups', true);

            axios.get(this.groupsUrl)
                .then((response) => {
                    this.setLoadingStatus('groups', false);

                    this.groups = {
                        status: response.data.status,
                        data: response.data.data
                    };
                }).catch((error) => {
                    this.setLoadingStatus('groups', false);

                    console.error(error);

                    this.groups = {
                        status: 'error',
                        data: []
                    };
                });
        },

        loadFields(group) {
            if(this.loading.fields === true) {
                return;
            }

            this.setLoadingStatus('fields', true);

            axios.get(this.fieldsUrl.replace(':group', group.id))
                .then(response => {
                    this.setLoadingStatus('fields', false);

                    this.fields = {
                        status: response.data.status,
                        data: response.data.data,
                        group: group
                    };
                })
                .catch(error => {
                    this.setLoadingStatus('fields', false);

                    console.error(error);

                    this.fields = {
                        status: 'error',
                        data: []
                    };
                })
        },

        selectGroup(group) {
            this.selectedFields = [];

            this.loadFields(group);
        },

        toggleField(field) {
            if(field.status === 1) {
                return;
            }

            let index = this.selectedFields.indexOf(field.id);

            if (index === -1) {
                this.selectedFields.push(field.id);
            } else {
                this.selectedFields.splice(index, 1);
            }
        },

        toggleAllFields() {
            if(this.selectedFields.length !== this.fields.data.length) {
                this.selectedFields = [];
                this.fields.data.forEach((field) => {
                    this.selectedFields.push(field.id)
                });
            } else {
                this.selectedFields = [];
            }
        },

        isChecked(field) {
            return this.selectedFields.indexOf(field.id) !== -1;
        },

        shape(field) {
            return "";
        },

        importFields() {
            if(this.loading.import === true) {
                return true;
            }

            this.setLoadingStatus('import', true);

            axios.post(this.importUrl.replace(':company', this.company_id), {
                fields: this.selectedFields,
                group: this.fields.group,
            }).then(response => {
                this.setLoadingStatus('import', false);

                if(response.data.status === 'success') {
                    this.$eventBus.$emit('alert', 'success', response.data.message, true, 5);
                } else {
                    this.$eventBus.$emit('alert', 'error', this.importErrorMessage, true, 5);
                }

                this.selectGroup(this.fields.group);
            })
            .catch(error => {
                this.setLoadingStatus('import', false);

                this.$eventBus.$emit('alert', 'error', this.importErrorMessage, true, 5);

                console.error(error)

                this.selectGroup(this.fields.group);
            })
        },

        goBackToGroups() {
            this.fields = {
                status: null,
                data: [],
                group: {}
            };
        },
    }
}
</script>

<style scoped>

</style>
